import React from 'react';

import { ActiveListIcon, ListIcon } from 'containers/Dashboard/components/SideBar/Icons/ListIcon';
import { ActiveRiskIcon, RiskIcon } from 'containers/Dashboard/components/SideBar/Icons/RiskIcon';
import {
  ActiveFormTemplateIcon,
  FormTemplateIcon,
} from 'containers/Dashboard/components/SideBar/Icons/FormTemplatesIcon';
import type { ProductType } from 'ui/NewSideBar/types';

import routes from 'core/routes';

import SessionUser from 'stores/Session/SessionUser';

import { risksRegisterPath } from 'utils/risksRegisterPath';
import { canAuthorRiskAssessmentTemplates } from 'utils/roles/permissions';

import { ControlsNavIcon, HazardsNavIcon } from './styles';

const LIBRARY_PATHS = [routes.dashboard.risks.controls.toString(), routes.dashboard.risks.hazards.toString()];

const underLibrary = (pathname: string, libraryPath?: string): boolean =>
  (libraryPath ? [libraryPath] : LIBRARY_PATHS).some((path) => pathname.startsWith(path));

export const risksProduct = (pathname: string, user: SessionUser): ProductType => {
  const to = risksRegisterPath(user);
  const isSelected = pathname.startsWith(routes.dashboard.risks.toString());
  const templatesRoute = routes.dashboard.risks.templates.toString();
  const isTemplates = pathname.startsWith(templatesRoute);

  return {
    name: 'Risks',
    testId: 'sidebar-risks',
    Icon: <RiskIcon />,
    ActiveIcon: <ActiveRiskIcon />,
    to,
    isSelected,
    subItems: [
      {
        name: 'Risk register',
        testId: 'sidebar-risks-risk-register',
        Icon: <ListIcon />,
        ActiveIcon: <ActiveListIcon />,
        to,
        isSelected: isSelected && !isTemplates && !underLibrary(pathname),
      },
      {
        name: 'Hazard library',
        testId: 'sidebar-risks-hazards',
        Icon: <HazardsNavIcon />,
        ActiveIcon: <HazardsNavIcon $active />,
        to: LIBRARY_PATHS[1],
        isSelected: underLibrary(pathname, LIBRARY_PATHS[1]),
      },
      {
        name: 'Controls library',
        testId: 'sidebar-risks-controls',
        Icon: <ControlsNavIcon />,
        ActiveIcon: <ControlsNavIcon $active />,
        to: LIBRARY_PATHS[0],
        isSelected: underLibrary(pathname, LIBRARY_PATHS[0]),
      },
      ...(canAuthorRiskAssessmentTemplates(user)
        ? [
            {
              name: 'Risk assessment templates',
              testId: 'sidebar-risks-templates',
              Icon: <FormTemplateIcon />,
              ActiveIcon: <ActiveFormTemplateIcon />,
              to: templatesRoute,
              isSelected: isTemplates,
            },
          ]
        : []),
    ],
  };
};
